import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';

import { BodyStyleContainer } from './BodyStyleContainer';
import { useProcessVehicles } from '../hooks/useProcessVehicles';
import { useBuildTabs } from '../hooks/useBuildTabs';
import { groupUniqueVehicles } from '../utils/groupUniqueVehicles';

import Tab from './Tab';
import Tabs from './Tabs';

export const TabbedBodyStyles = ({ data }) => {
	const labels = useLabels();
	const { showTabs } = usePrefs();
	const allLabel = labels.get('ALL');
	const tabSliderRef = React.useRef();
	const vehicles = useProcessVehicles(data);
	const tabNames = useBuildTabs(vehicles);
	const [activeTab, setActiveTab] = useState(tabNames[0]);
	const defaultTab = tabNames[0] === allLabel ? allLabel : tabNames[0];

	const getTabContent = (tabTitle) => {
		const tabVehicles = vehicles[tabTitle];
		if (tabVehicles) {
			return <BodyStyleContainer vehiclesArray={tabVehicles} />;
		} else {
			return null;
		}
	};

	// The drawer/mega "Shop by Model" surfaces read as a plain model list, not a
	// tabbed widget. When showTabs is 'false' skip the <Tabs> chrome entirely and
	// render EVERY model directly. `tabNames[0]` is the All tab only when
	// showAllModelsTab is 'true'; the fragment config sets it 'false', so
	// tabNames[0] is just the first body-style group (one/few models). Instead
	// render the deduped union of every group so the surface always shows the
	// full catalog independent of showAllModelsTab / tab order. Default ('true')
	// keeps the tab bar exactly as before.
	if (showTabs === 'false') {
		return (
			<BodyStyleContainer vehiclesArray={groupUniqueVehicles(vehicles)} />
		);
	}

	const tabArray = React.Children.toArray(
		tabNames.map((tabName) => (
			<Tab
				title={tabName}
				eventKey={tabName}
				tabClassName="tab-item ddc-font-size-base mx-2"
			>
				{getTabContent(tabName)}
			</Tab>
		))
	);

	return (
		<Tabs
			ref={tabSliderRef}
			activeKey={activeTab}
			onSelect={setActiveTab}
			id="tabbed-model-selector"
			defaultActiveKey={defaultTab}
		>
			{tabArray}
		</Tabs>
	);
};

TabbedBodyStyles.propTypes = {
	data: PropTypes.objectOf(
		PropTypes.arrayOf(
			PropTypes.shape({
				year: PropTypes.number,
				make: PropTypes.string,
				model: PropTypes.string,
				modelInv: PropTypes.string,
				gvBodyStyle: PropTypes.string,
				image: PropTypes.string,
				inventoryCount: PropTypes.number
			})
		)
	).isRequired
};
